export default __webpack_public_path__ + "bc800f3b9286b71005c3f026ebfaa958.svg";